import { BlockStack } from '@shopify/polaris';
import { DatePickerShow } from './components/DatePickerShow';
import { EmbedAppStatus } from './components/EmbedAppStatus';
import { WidgetPlaceManually } from './components/WidgetPlaceManually';
import { IResponseApi } from '@/types/apis/response';

interface Props {
  shopThemes: IResponseApi.IGetShopThemes[] | undefined;
}

const WidgetPosition = ({ shopThemes }: Props) => {
  return (
    <BlockStack gap={'500'}>
      <EmbedAppStatus shopThemes={shopThemes} />
      <DatePickerShow />
      <WidgetPlaceManually />
    </BlockStack>
  );
};

export default WidgetPosition;
